// @ts-nocheck
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { useUiStore } from "src/components/main/uiStore";
//---------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import {
    myAxios,
    MyDate
} from "src/components/common/functions";
import { useNavigate, useParams } from "react-router-dom";
//---------------------------------------------------------------------
export default function Yards({
    closeIt, 
    tabTitle
}){
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const navigate = useNavigate();
    const { settingId , action } = useParams();
    const [yardsData, setYardsData] = useState({});
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios({ fileName: "fleet/readInventoryYards.php" });
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------------------------
            setYardsData(res.data);
        }
        getData();
        return () => isMounted = false;
    }, [setShowLoader])
    return (
        <Modal
            closeIt = {closeIt}
            title = {"Yards"}
            width = {"60%"}
            actionKey = "Save"
            handleFormSubmit = {async() => {
                if(Object.values(yardsData).map(({title}) => title).some((item, index, self) => self.indexOf(item) !== index)){
                    window.alert("Some titles are duplicated.");
                    return;
                }
                const formData = new FormData();
                formData.append("data", JSON.stringify(yardsData));
                //---------------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios({ fileName: "fleet/updateYardInventory.php", formData: formData });
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------------
                closeIt();
            }}
        >
            {Object.entries(yardsData).map(([key, value], index) => 
            <li className = "my-3 d-flex align-items-center" key = {index}>
                <span>
                    Yard {index + 1}
                </span>
                <label
                    className = "ms-2"
                    htmlFor = {key + " qty"}
                >
                    Title
                </label>
                <input
                    className = {`ms-2 form-control flex-grow-1${Object.values(yardsData).filter(({title}) => title === value.title).length > 1?" text-danger":""}`}
                    id = {key + " qty"}
                    style = {{width: "100px"}}
                    value = {value.title}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        setYardsData({
                            ...yardsData, 
                            [key]: {
                                ...yardsData[key],
                                title: value
                            }
                        });
                    }}
                />
                <label className = "ms-2" htmlFor = {key + " yardNote"}>Note</label>
                <input
                    id = {key + " yardNote"}
                    className = {`ms-2 form-control flex-grow-1`}
                    value = {value.yardNote}
                    onChange = {e => {
                        const value = e.currentTarget.value;
                        setYardsData({
                            ...yardsData, 
                            [key]: {
                                ...yardsData[key],
                                yardNote: value
                            }
                        });
                    }}
                />
                <span>
                </span>
                <span>
                    <button type = "button" className = "btn btn-info ms-2" onClick = {() => {
                        navigate(`/${tabTitle}/Yards/${key}/order`);
                    }}>
                        ⇅
                    </button>
                    {action === "order"?
                    <Order
                        id = {settingId}
                        closeIt = {() => navigate(`/${tabTitle}/Yards`)}
                        setYardsData = {setYardsData}
                        yardsData = {yardsData}
                    />:<></>}
                </span>
                <button
                    className = "btn btn-danger ms-2"
                    type = "button"
                    onClick = {() => {
                        if(!window.confirm("Are you sure to delete this yard?\n(This action will remove all data from this yard.)")) return;
                        const newData = {...yardsData};
                        delete newData[key];
                        setYardsData(newData);
                    }}
                >
                    Delete
                </button>
            </li>)
            }
            <button
                type = "button"
                className = "btn btn-info my-2"
                onClick = {() => {
                    let rand = v4().slice(0, 8);
                    while(rand in yardsData){
                        rand = v4().slice(0, 8);
                    }
                    setYardsData({
                        ...yardsData, 
                        [rand]: {
                            title: "",
                            yardNote: "",
                            inventory: {},
                            updateTime: "",
                            createdTime: new MyDate().s() + " " + new MyDate().ss()
                        }
                    });
                }}
            >
                Add
            </button>
        </Modal>
    )
}

function Order({ id, yardsData, setYardsData, closeIt }){
    const arr = Object.entries(yardsData).map((entry, index) =>([...entry, index]));
    const originIndex = arr.find(entry => entry[0] === id)[2];
    const [target, setTarget] = useState("");
    return(
        <Modal
            touchOutsideClose
            closeIt = {closeIt}
            title = {"Change Order of " + yardsData[id].title}
            width = {"60%"}
            onSave = {() => {
                const result = [];
                if(!target){
                    result.push([id, yardsData[id]], ...arr.filter(entry => entry[0] !== id));
                }else{
                    let targetIndex = -1;
                    for(let i = 0; i < arr.length; i++){
                        if(arr[i][0] === target){
                            targetIndex = i;
                        }
                    }
                    result.push(
                        ...arr.slice(0, targetIndex + 1).filter(entry => entry[0] !== id), 
                        [id, yardsData[id]],
                        ...arr.slice(targetIndex + 1).filter(entry => entry[0] !== id)
                    )
                }
                setYardsData(Object.fromEntries(result));
                closeIt();
            }}
        >
            <div>
                <select
                    className = "form-control m-3"
                    value = {target}
                    onChange = {e => setTarget(e.currentTarget.value)}
                >
                    <option value = {""} disabled = {originIndex === 0}>
                        At the Top
                    </option>
                    {arr.map(([key, value], renderedIndex) => 
                    <option
                        disabled = {renderedIndex === originIndex || renderedIndex + 1 === originIndex}
                        key = {key}
                        value = {key}
                    >
                        After {value.title}
                    </option>
                    )}
                </select>
            </div>
        </Modal>
    );
}